module.exports = __webpack_public_path__ + "static/media/adchoices.2e80ffe5.png";